export default "__VITE_ASSET__ByAkslHw__"